import { tiles } from '../../../../common/tiles';

export default [
  { item: tiles.insights },
  { item: tiles.subjectSearch },
  { item: tiles.manageCohorts },
  { item: tiles.tasks },
  { item: tiles.files },
  { item: tiles.manageProjectKnowledge },
  { item: tiles.addData },
  { item: tiles.genomics },
  { item: tiles.manageSurveys },
  { item: tiles.manageProjectConsent },
  { item: tiles.ontologies },
  { item: tiles.lifeResearch },
  { item: tiles.trialMatching },
  { item: tiles.contentManagement },
  { item: tiles.ml },
  { item: tiles.workflows },
];
